/** Must match Google OAuth consent screen app name exactly. */
export const APP_NAME = "yourfriendally";

export const APP_DOMAIN = "yourfriendally.com";

export const APP_TAGLINE = "Like texting a friend who actually follows through.";

/** Conversational assistant name in product copy (SMS, chat). */
export const ASSISTANT_NAME = "Ally";

/** Circular Ally mascot — served from public/ for favicon + in-app img. */
export const ALLY_AVATAR_URL = `${process.env.PUBLIC_URL || ""}/ally-avatar.png`;
